import { useState } from "react";
import { Bell, Search, ChevronDown, Menu } from "lucide-react";

export default function Topbar({ toggleSidebar }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="flex items-center justify-between bg-white px-6 py-4 shadow-sm">
      
      {/* Search */}
        <div className="hidden md:flex items-center bg-gray-100 px-3 py-2 rounded-lg">
          <Search size={18} className="text-gray-500" />
          <input
            type="text"
            placeholder="Search..."
            className="bg-transparent outline-none ml-2 text-sm"
          />
        </div>

      {/* Right Section */}
      <div className="flex items-center gap-6">

        {/* Notification */}
        <div className="relative cursor-pointer">
          <Bell size={22} className="text-gray-600" />
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs px-1 rounded-full">
            3
          </span>
        </div>

        {/* Profile Dropdown */}
        <div className="relative">
          <div
            onClick={() => setOpen(!open)}
            className="flex items-center gap-2 cursor-pointer"
          >
            <img
              src="https://i.pravatar.cc/40"
              alt="user"
              className="w-9 h-9 rounded-full"
            />
            <ChevronDown size={18} />
          </div>

          {open && (
            <div className="absolute right-0 mt-3 w-40 bg-white shadow-lg rounded-lg py-2">
              <div className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                Profile
              </div>
              <div className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                Settings
              </div>
              <div className="px-4 py-2 hover:bg-red-100 text-red-600 cursor-pointer">
                Logout
              </div>
            </div>
          )}
        </div>

      </div>
    </div>
  );
}
